import type { IconSvgObject } from './types';

const Touch04Icon: IconSvgObject = [
  ["path", { d: "M8 14.5V10.5M8 10.5V4.25C8 3.2835 8.7835 2.5 9.75 2.5C10.7165 2.5 11.5 3.2835 11.5 4.25V10.5H16C17.6569 10.5 19 11.8431 19 13.5V18.5C19 20.1569 17.6569 21.5 16 21.5H9.5841C8.90785 21.5 8.27739 21.1583 7.90829 20.5916L5.98731 17.6426C5.11571 16.3152 5.01657 15.7011 5.00083 15.0302C4.99373 14.7276 5.03246 14.4256 5.11571 14.1346C5.30031 13.4894 5.77679 12.9448 6.7297 11.8558L8 10.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Touch04Icon;
